import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const CatalogContext = createContext(null);
export function CatalogProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const refreshCategories = useCallback(async () => {
    try { const { data } = await api.get("/categories"); setCategories(data); setError(""); }
    catch { setError("Categories could not be loaded. Please try again."); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => {
    refreshCategories();
    window.addEventListener("focus", refreshCategories);
    return () => window.removeEventListener("focus", refreshCategories);
  }, [refreshCategories]);
  return <CatalogContext.Provider value={{ categories, loading, error, refreshCategories }}>{children}</CatalogContext.Provider>;
}
export const useCatalog = () => useContext(CatalogContext);
